module.exports = __webpack_public_path__ + "static/media/kid-choc-cupcake.32adfbc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-choc-cupcake.jpg
// module id = 802
// module chunks = 0